"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateRequest = void 0;
var UpdateRequest = /** @class */ (function () {
    function UpdateRequest() {
    }
    return UpdateRequest;
}());
exports.UpdateRequest = UpdateRequest;
;
//# sourceMappingURL=update.request.js.map